export function getMHTrackingId() {
  const storageKey = "mh-device-tracking";

  // Try to get from localStorage
  let distinctId = localStorage.getItem(storageKey);
  if (!distinctId) {
    // If not found, generate a new one
    distinctId = generateUUID();
    localStorage.setItem(storageKey, distinctId);
  }

  return distinctId;
}

function generateUUID() {
  // RFC4122 version 4 compliant UUID
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
